import React from 'react';
import { Link } from 'react-router-dom'

import Contacts from 'components/contacts/Contacts';
import { default as VideoIntro } from './components/videoIntro/VideoIntroContainer';
import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

import mountain1 from 'assets/img/stock/capetown/mountain_1.jpg';
import gameDrive from 'assets/img/stock/botswana/gamedrive.jpg';
import vicFalls3 from 'assets/img/stock/vfalls/vfalls_3.jpg';

export default () =>
    <div className="fullheight">
        <Navbar />
        <VideoIntro />
        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-10 p-30 p-b-60">
                        <h3>Welcome</h3>
                        <p className="dark-text">
                            Southern Africa Dream Tours and Safaris wants to
                            take you for an ultimate trip to the safest part of
                            Africa, the select five countries : South Africa,
                            Botswana, Namibia, Zambia and Zimbabwe. In addition,
                            we will take you to the most exotic and beautiful
                            islands of Seychelles and Mauritius. Experience
                            three of the world’s seven wonders of the world in
                            one package.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        {/*<!--Sales-->*/}
        <section className="boxes" id="sales">
            <div className="container-fluid">
                {/*<!-- Title -->*/}
                <h4 className="sml_abs_title wow fadeInUp">Destinations</h4>

                <div className="row">
                    {/*<!-- col -->*/}
                    <div
                        className="col-md-12 bordered_block grey_border image_bck"
                        data-image={mountain1}
                    >
                        {/*<!-- Over -->*/}
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 wow fadeInLeft">
                                    <span className="great_title">
                                        Table Mountains
                                    </span>
                                    <span className="great_subtitle great_subtitle_big">
                                        Capetown, South Africa
                                    </span>
                                    <span className="into_txt">
                                        The Table Mountain, recently named as
                                        one of the new 7 wonders of the world,
                                        is an iconic formation that projects out
                                        of the earth’s surface and stands erect,
                                        as one of the world’s amazing sculptures
                                        of nature. This 600 years old sandstone
                                        formation is splendid to gaze at, it is
                                        invigorating to hike on, it is amazing
                                        to ride a cable-car on. It is
                                        awe-striking to see the Indian and the
                                        Atlantic Ocean meet, fight or wave along
                                        beneath it. <br />The renewing breeze
                                        and the exhilarating feeling of being on
                                        top this natures’ wonder, while at the
                                        same time being mesmerized by the
                                        beautiful waters of the ocean waving
                                        along gently in the ocean below, just
                                        slightly kissing, truly touches your
                                        soul. The city below, built with skill
                                        and desire to impress, might just make
                                        you wonder why you did not think of
                                        taking this trip long before. Well! It’s
                                        never too late, you can always go now
                                        and come back many times. You are most
                                        welcome here, bring your family and
                                        friends so they can experience the
                                        beauty of life and the wonders of the
                                        world we all call home. <br />Here is a
                                        glimpse of Table Mountain in pictures.
                                        See pictures now, but be sure to
                                        actually plan to experience wild
                                        Africa!!
                                    </span>
                                    <br />
                                    <span>
                                        <Link
                                            to="/gallery-capetown"
                                            className="btn btn-white m-t-20"
                                        >
                                            See more
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<!-- Col End -->*/}

                    {/*<!-- col -->*/}
                    <div
                        className="col-md-12 bordered_block grey_border image_bck"
                        data-image={vicFalls3}
                    >
                        {/*<!-- Over -->*/}
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 wow fadeInUp text-left">
                                    <span className="great_title">
                                        Victoria falls
                                    </span>
                                    <span className="great_subtitle great_subtitle_big">
                                        Zimbabwe & Zambia
                                    </span>
                                    <span className="into_txt">
                                        The largest curtain of falling water in
                                        the whole world, the mighty Victoria
                                        Falls, and the so called Garden of Eden,
                                        tucked between four countries, Botswana,
                                        Namibia, Zimbabwe and Zambia, the
                                        Okavango Delta which has diverse and
                                        impressive fauna and flora. <br /> Meet
                                        the unique people, experience their
                                        unique cultures, hear and be amazed by
                                        their unique languages and songs.
                                        Experience a different and intense hue
                                        and sun rays and see how that makes the
                                        fauna in this region unique as it adapts
                                        to this ever-changing climate. YES!
                                        Together lets unlock the hidden
                                        treasures of life and our world!
                                    </span>
                                    <br />
                                    <span>
                                        <Link
                                            to="/gallery-vicfalls"
                                            className="btn btn-white m-t-20"
                                        >
                                            See more
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<!-- Col End -->*/}

                    {/*<!-- col -->*/}
                    <div
                        className="col-md-12 bordered_block grey_border image_bck"
                        data-image={gameDrive}
                    >
                        {/*<!-- Over -->*/}
                        <div
                            className="over"
                            data-opacity="0.5"
                            data-color="#292929"
                        />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 wow fadeInRight text-left">
                                    <span className="great_title">
                                        Okavango delta
                                    </span>
                                    <span className="great_subtitle great_subtitle_big">
                                        Botswana, Namibia, Zambia & Zimbabwe
                                    </span>
                                    <span className="into_txt">
                                        Adventure into Africa’s wild bush for an
                                        ultimate safari and meet the “Big Game
                                        Five”, the elephant, buffalo, lion,
                                        rhinoceros and leopard, and of course
                                        there is also the majestic zebra, the
                                        elegant giraffe, the goofy hippopotamus,
                                        the colorful birds and all other unique
                                        wild animals for your enjoyment.
                                    </span>

                                    <br />
                                    <span>
                                        <Link
                                            to="/gallery-okavango"
                                            className="btn btn-white m-t-20"
                                        >
                                            See more
                                        </Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<!-- Col End -->*/}
                </div>
                {/*<!-- Row End -->*/}
            </div>
        </section>
        {/*<!--Sales End-->*/}

        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-10 p-30 p-b-60">
                        <h3>Our promise</h3>
                        <p className="dark-text">
                            Southern Africa Dream Tours and Safaris connects you
                            to the experts and the best in African Safari and
                            tour planning. The chosen team of experts have years
                            of experience and vast knowledge of the destination
                            locations, the culture, the people, and the best
                            sites to visit. Dream tours strives to ensure that
                            your trip is seamless and smooth by ensuring that
                            you are well informed of the destination, activities
                            and rigor, safety and health, and above all create
                            the most memorable vacation of all.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section className="boxes themeBG">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-10 p-30 p-b-60">
                        <h3>Why Southern African Dream tours</h3>
                        <p className="dark-text">
                            We care passionately about your individual
                            experience, because you are important! We strive to
                            go above and beyond your expectations. We want you
                            to be worry free, as such we are informing you that
                            Southern Africa is one of the safest destinations
                            with world class accommodation, activities and
                            cuisine. In addition to the superb and clean
                            environment, we can inject upscale photography "that
                            which pull out the beauty in you while you are
                            having a good time", healthcare provisions such as a
                            nurse, if needed, access to worldclass doctors,
                            provision of a baby sitter if needed. We cater for
                            everyone's individual needs per our ability, just to
                            make your vacation that much more special. We will
                            make you a home away from home and we will make it
                            so well you will want to come back!
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <Contacts />
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/home/Home.jsx